module.exports = __webpack_public_path__ + "media/images/flags/16/Somaliland-20751a570dda7c557743b129cea45a91.png";